import React from 'react'
import PropTypes from 'prop-types';
import './Form.css';
import { TextField, Button, CircularProgress, Snackbar, Slide, FormControl, InputLabel, Select, MenuItem, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';


class Form extends React.Component {

  static propTypes = {
    data: PropTypes.any
  }

  state = {
    form: {
      fields: [],
      options: [],
      invalid: true,
    },
    defaultLoad: false,
    loading: false,
    sbOpen: false,
    sbMsg: ''
  }

  componentDidMount() {
    var fields = this.props.form.fields.map((field) => ({ ...field, invalid: true, blur: false }))
    this.setState({ form: { ...this.props.form, fields: fields } }, this.isValid);
  }

  static getDerivedStateFromProps(props, state) {

    // console.log(props, state);
    // console.log(props.form);
    if (state.form.fields.length > 0) {
      // ya hay form en state

      // var fields = state.form.fields, change = false;
      // if(state.form !== props.form)
      //   change = true;

      var fields = state.form.fields, change = false;
      fields.forEach((field, i) => {
        props.form.fields.forEach((propField) => {
          if (field.name === propField.name && field.options !== propField.options) {
            // console.log('options', propField.options);
            fields[i].options = propField.options;
            change = true;
          }
        })
      })
      if (props.form.fields !== state.form.fields)
        change = true;
      if (props.default && !state.defaultLoad) {
        // console.log(props.default, state.defaultLoad);
        for (let prop in props.default) {
          fields.forEach((field, i) => {
            if (field.name === prop) {
              fields[i].value = props.default[prop];
              fields[i].invalid = false;
            }
          })
          // console.log(fieldsDef);
        }
        // fDefault = true;
        state.defaultLoad = true;
        state.form.invalid = false;
        change = true;
      }
      // console.log('fdef', fDefault);

      if (change)
        return { ...state, form: { ...state.form, fields: fields } }
    }
    // console.log('desde props, ');

    return { ...props, form: { ...props.form, invalid: state.form.invalid } };
  }

  onLoad = (msg = 'Cargado', rest = true) => {
    this.setState({ loading: false, sbMsg: msg, sbOpen: true, defaultLoad: false });
    if (rest) {
      var fields = this.state.form.fields;
      fields = fields.map((field) => ({ ...field, value: '' }))
      // console.log('rest', fields);
      this.setState({ form: { ...this.state.form, fields: fields } })
    }
  }

  submit = (i) => {
    this.setState({ loading: true });
    var vals = {};
    this.state.form.fields.forEach((field) => {
      vals[field.name] = field.value;
    })
    // var vals = this.state.form.fields.map((field) => ({[field.name]: field.value}))
    this.props.onSubmit(i + 1, vals, this.onLoad, this.state.form)
  }

  fieldProp = (field, prop, newVal) => {
    var fields = this.state.form.fields;
    var idx = fields.findIndex((val, i) => val.name === field.name);
    fields[idx][prop] = newVal;
    this.setState({ form: { ...this.state.form, fields: fields } })
    // console.log(fields[1].blur);

  }

  valueChange = (field, val) => {
    this.fieldProp(field, 'value', val);
    this.isValidField(field, val);
  }

  blur = (field, val) => {
    this.isValidField(field, val);
  }

  isValidField = (field, val) => {
    field.validators.forEach((validator) => {
      this.fieldProp(field, 'blur', true);
      // console.log(validator);
      if (!validator(val)) {
        this.fieldProp(field, 'invalid', true);
        this.setState({ form: { ...this.state.form, invalid: true } })
      }
      else
        this.fieldProp(field, 'invalid', false);
    });
    this.isValid();
  }

  isValid = () => {
    const { fields } = this.state.form
    for (var i in fields) {
      // console.log(fields[i]);
      if (fields[i].invalid) {
        this.setState({ form: { ...this.state.form, invalid: true } })
        // console.log('asd');
        break;
      }
      this.setState({ form: { ...this.state.form, invalid: false } })
    }
    // console.log(this.state.form.invalid);
  }

  render() {
    const { form, loading, sbMsg, sbOpen } = this.state;
    // console.log('render form', form.invalid);
    return (
      <div>
        {form.title &&
          <h1>{form.title}</h1>
        }
        <div className="row row-form">
          {form.fields.map((formField, i) => {

            if (formField.type === 'text' || formField.type === 'number')
              return (
                <div key={i} className={`col-12 col-sm-${formField.col}`}>
                  <TextField autoFocus={i === 0} variant="outlined" className="form-field" type={formField.type} label={formField.label} value={formField.value} onChange={(e) => { this.valueChange(formField, e.target.value) }} onBlur={(e) => { this.blur(formField, e.target.value) }} />
                </div>
              )

            if (formField.type === 'select')
              return (
                <div key={i} className={`col-12 col-sm-${formField.col}`}>
                  <FormControl variant="outlined" className='form-field'>
                    <InputLabel>{formField.label}</InputLabel>
                    <Select autoFocus={i === 0}
                      value={formField.value}
                      onChange={(e) => { this.valueChange(formField, e.target.value) }}
                      onBlur={(e) => { this.blur(formField, e.target.value) }}
                    >
                      {formField.options.map((option, i) => {
                        return (<MenuItem value={option.value} key={i}>{option.label}</MenuItem>)
                      })}
                    </Select>
                  </FormControl>
                </div>
              )

            if (formField.type === 'radio')
              return (
                <div key={i} className={`col-12 col-sm-${formField.col}`}>
                  <FormControl>
                    <FormLabel>{formField.label}</FormLabel>
                    <RadioGroup autoFocus={i === 0} aria-label={formField.label} name={formField.name} value={formField.value} onChange={(e) => { this.valueChange(formField, e.target.value) }} onBlur={(e) => { this.blur(formField, e.target.value) }}>
                      {formField.options.map((option, i) =>
                        <FormControlLabel key={i} value={option.value.toString()} control={<Radio />} label={option.label} />
                      )}
                    </RadioGroup>
                  </FormControl>
                  {/* <TextField variant="outlined" className="form-field" type={formField.type} label={formField.label} value={formField.value} onChange={(e) => { this.valueChange(formField, e.target.value) }} onBlur={(e) => { this.blur(formField, e.target.value) }} /> */}
                </div>
              )
            return (<div key={i} className='col-12'>'{formField.type}' no creado en formulario</div>)
          })}
        </div>
        <div className="options">
          {form.options.map((label, i) => {
            return (
              <Button key={i} variant="contained" color={i < 1 ? 'primary' : 'secondary'} disabled={form.invalid || loading} onClick={() => { this.submit(i) }}>
                {i === 0 &&
                  <div style={{ marginRight: 10, padding: 0, height: 22 }} hidden={!loading}><CircularProgress color="secondary" size={20} /></div>
                }
                {label}
              </Button>
            )
          })}
        </div>



        <Snackbar
          open={sbOpen}
          onClose={() => { this.setState({ sbOpen: false }) }}
          TransitionComponent={Slide}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{sbMsg}</span>}
        />
      </div>
    )
  }
}

export default Form;
